import { OptionsType } from '@openx/types/options';
import type { SelectRateFormState } from '@openx/types/targeting/selectRate';
import { TargetingFields, type TargetingProps } from '@openx/types/targeting/targeting';
import { noop } from '@openx/utils/noop';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { viewabilityTierLabel } from '../shared/SelectRate/constants';
import { SelectRate } from '../shared/SelectRate/SelectRate';

export function Viewability({
  targetingParams,
  onFieldUpdate = noop,
  name,
  readonly,
}: TargetingProps<SelectRateFormState>) {
  const [userChangedInitialValue, setUserChangedInitialValue] = useState(false);
  const { t } = useTranslation();

  const onFieldUpdateExtended = useCallback(
    (...args: Parameters<typeof onFieldUpdate>) => {
      setUserChangedInitialValue(true);
      onFieldUpdate(...args);
    },
    [onFieldUpdate]
  );

  return (
    <SelectRate
      targetingParams={targetingParams}
      onFieldUpdate={onFieldUpdateExtended}
      name={name}
      readonly={readonly}
      field={TargetingFields.VIEWABILITY}
      userChangedInitialValue={userChangedInitialValue}
      placeholder={viewabilityTierLabel}
      filterTitle={viewabilityTierLabel}
      optionsFetch={OptionsType.VIEWABILITY}
      dataTest="viewability"
      description={t(
        'Optimize for ad placements based on expected viewability thresholds to enhance visibility and performance. Not applicable for CTV deals.'
      )}
    />
  );
}
